import React from 'react';
import { useSmartProp, useEditor } from '@smartfire/wordpress-react';

import { RichText } from '@wordpress/block-editor';

export default function EditableDiv({
  smartProp,
  className,
  style,
  render = function(value, props = {}) {
    return <div dangerouslySetInnerHTML={{ __html: value }} {...props} />;
  },
  ...props
}) {
  const [value, updateValue] = useSmartProp(smartProp);
  const { isEditing } = useEditor();
  if (isEditing) {
    return (
      <div className={className}>
        <RichText
          tagName="div"
          placeholder={'...'}
          formattingControls={[]}
          value={value}
          className={'editableInput'}
          onChange={updateValue}
          {...props}
        />
      </div>
    );
  } else {
    return render(value, {
      className,
      style,
    });
  }
}
